/* eslint-disable no-dupe-keys */
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import { useParams, useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';
import cirpImage from '../assets/logok.png';
import WhatsAppButton from '../components/WhatsAppButton';
import LandingChatbot from '../components/LandingChatbot';
import { Helmet } from 'react-helmet';
import useFacebookPixel from '../hooks/useFacebookPixel';
import SocialButtons from '../components/SocialButton';
import MicrosoftClarity from '../components/MicrosoftClarity';
import './usuario.css';
import './recuadro.css';
import './AudienciaLanding.css';

const Producto3 = () => {
  const { usuario } = useParams();
  useFacebookPixel(usuario);
  const { trackContact, trackViewContent } = useFacebookPixel(usuario);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [userdata, setUserdata] = useState({});
  const [Pixels, setPixels] = useState('');
  const [Clarity, setClarity] = useState('');
  const [showQuestion, setShowQuestion] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);
  const playerRef = useRef(null);

  const fetchUserInfo = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/infocampanas/${usuario}`
      );
      setUserdata(response.data[0]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchData = async () => {
    try {
      const response = await axios.get(`https://api.mrcirp.com/public/usuariolanding/${usuario}`);
      setData(response.data[0]);
    } catch (error) {
      console.error("Error fetching user info:", error);
    }
  };

  const pixelsuser = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/userpixels/${usuario}`
      );
      setPixels(response.data[0]);
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  const clarityuser = async () => {
    try {
      const response = await axios.get(
        `https://api.mrcirp.com/public/userclarity/${usuario}`
      );
      setClarity(response.data[0]);
    } catch (error) {
      console.error('Error fetching user info:', error);
    }
  };

  useEffect(() => {
    fetchData();
    fetchUserInfo();
    pixelsuser();
    clarityuser();
  }, [usuario]);

  const handleEnded = () => {
    setShowQuestion(true);
    setVideoEnded(true);
  };

  const handleReplay = () => {
    setShowQuestion(false);
    setVideoEnded(false);
    playerRef.current.seekTo(0);
  };

  const handleOptionB = () => {
    trackViewContent();
    navigate(`/unirsecliente/${usuario}`);
  };

  const handleOptionC = () => {
    navigate('/salir');
  };

  const handleBack = () => {
    navigate(-1);
  };

  if (!data) {
    return <div>Loading...</div>;
  }

  // Parsear servicios_items de revelación
  let revelacionServiciosItems = [];
  if (data.revelacion_servicios_items) {
    try {
      revelacionServiciosItems = typeof data.revelacion_servicios_items === 'string' 
        ? JSON.parse(data.revelacion_servicios_items) 
        : data.revelacion_servicios_items;
      if (!Array.isArray(revelacionServiciosItems)) revelacionServiciosItems = [];
    } catch (e) {
      console.error('Error parsing revelacion_servicios_items:', e);
    }
  }

  const hasAnySocialLink = 
    (userdata && userdata.pdf) || 
    (userdata && userdata.facebook) || 
    (userdata && userdata.instagram) || 
    (userdata && userdata.linkedin) || 
    (userdata && userdata.tiktok) || 
    (userdata && userdata.calendly);

  return (
    <div style={styles.container}>
      <Helmet>
        <title>{usuario} - Producto 3</title>
        <meta name="description" content={`Pixels: ${Pixels}`} />
      </Helmet>
      {Clarity?.clarity && <MicrosoftClarity trackingId={Clarity.clarity} />}
      {/* Banner Section */}
      <div 
        style={{
          ...styles.bannerSection,
          backgroundImage: data.revelacion_banner_imagen_url ? `url(${data.revelacion_banner_imagen_url})` : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          minHeight: 'auto',
          paddingBottom: '60px'
        }}
      >
        <div style={styles.content}>
          {/* Título y subtítulo del banner encima del video */}
          {(data.revelacion_banner_titulo || data.revelacion_banner_subtitulo) && (
            <div style={styles.bannerContent}>
              {data.revelacion_banner_titulo && (
                <h1 
                  style={styles.bannerTitle}
                  dangerouslySetInnerHTML={{ __html: data.revelacion_banner_titulo }}
                />
              )}
              {data.revelacion_banner_subtitulo && (
                <p 
                  style={styles.bannerSubtitle}
                  dangerouslySetInnerHTML={{ __html: data.revelacion_banner_subtitulo }}
                />
              )}
            </div>
          )}

          {/* Video de Producto 3 */}
          <div className="row">
            <div className={showQuestion ? "col-md-6 col-sm-12" : "col-md-12 col-sm-12"}>
              {data.urlvideoproducto3 && (
                <div style={{ maxWidth: '800px', margin: '40px auto 0', width: '100%' }}>
                  <div style={{ position: 'relative', width: '100%', paddingTop: '56.25%' }}>
                    {!videoEnded ? (
                      <ReactPlayer
                        ref={playerRef}
                        url={data.urlvideoproducto3}
                        width="100%"
                        height="100%"
                        controls={false}
                        onEnded={handleEnded}
                        style={{ position: 'absolute', top: 0, left: 0 }}
                      />
                    ) : (
                      <div className="recuadro" style={styles.replayContainer}>
                        <img src={cirpImage} alt="KATANA" style={styles.replayImage} />
                        <button style={styles.button} onClick={handleReplay}>Reproducir nuevamente</button>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>

            {showQuestion && (
              <div className="col-md-6 col-sm-12">
                <div className="recuadro" style={styles.question}>
                  <h4 style={{ color: '#333', marginBottom: '24px', fontSize: '20px', fontWeight: '600' }}>
                    {data?.banner_pregunta_texto || '¿Qué le pareció el video? … ¿Sorprendente cierto? ¿Como deseas continuar?'}
                  </h4>
                  <button style={styles.button} onClick={handleOptionB}>
                    {data?.banner_boton_b ? `B) ${data.banner_boton_b}` : 'B) QUIERO UNIRME AL EQUIPO'}
                  </button>
                  <button style={styles.button} onClick={handleOptionC}>
                    {data?.banner_boton_c ? `C) ${data.banner_boton_c}` : 'C) NO GRACIAS, DESEO SALIR'}
                  </button>
                  <button style={styles.button} onClick={handleBack}>
                    {data?.banner_boton_volver || 'VOLVER'}
                  </button>
                </div>
              </div>
            )}
          </div>

        </div>
      </div>

      {/* Sección de Servicios */}
      {data.revelacion_servicios_titulo && (
        <section className="servicios-section">
          <div className="container">
            <div className="section-header">
              <h2 
                className="section-title"
                dangerouslySetInnerHTML={{ __html: data.revelacion_servicios_titulo || '' }}
              />
              {data.revelacion_servicios_descripcion && (
                <p 
                  className="section-description"
                  dangerouslySetInnerHTML={{ __html: data.revelacion_servicios_descripcion }}
                />
              )}
            </div>
            
            {revelacionServiciosItems.length > 0 && (
              <div className="servicios-grid">
                {revelacionServiciosItems.map((item, index) => (
                  <div key={index} className="servicio-card">
                    <h3 
                      className="servicio-title"
                      dangerouslySetInnerHTML={{ __html: item.titulo || '' }}
                    />
                    <p 
                      className="servicio-description"
                      dangerouslySetInnerHTML={{ __html: item.descripcion || '' }}
                    />
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Izquierda) */}
      {data.revelacion_dos_columnas_titulo && (
        <section className="dos-columnas-section">
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-left">
                {data.revelacion_dos_columnas_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.revelacion_dos_columnas_imagen} 
                      alt={data.revelacion_dos_columnas_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_titulo || '' }}
                />
                {data.revelacion_dos_columnas_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_descripcion }}
                  />
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Sección de Dos Columnas (Imagen Derecha) */}
      {data.revelacion_dos_columnas_derecha_titulo && (
        <section 
          className="dos-columnas-section reverse"
          style={{
            backgroundImage: data.revelacion_dos_columnas_derecha_fondo_imagen ? `url(${data.revelacion_dos_columnas_derecha_fondo_imagen})` : 'none',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundAttachment: 'fixed'
          }}
        >
          <div className="container">
            <div className="dos-columnas-content">
              <div className="column-right">
                <h2 
                  className="section-title"
                  dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_derecha_titulo || '' }}
                />
                {data.revelacion_dos_columnas_derecha_descripcion && (
                  <p 
                    className="section-description"
                    dangerouslySetInnerHTML={{ __html: data.revelacion_dos_columnas_derecha_descripcion }}
                  />
                )}
              </div>
              <div className="column-left">
                {data.revelacion_dos_columnas_derecha_imagen && (
                  <div className="image-container">
                    <img 
                      src={data.revelacion_dos_columnas_derecha_imagen} 
                      alt={data.revelacion_dos_columnas_derecha_titulo}
                      className="section-image"
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
      )}

      {/* Footer */}
      <footer className="landing-footer">
        <div className="container">
          <div className="footer-content">
            <p className="footer-text">
              © 2024 KATANA - Constructor de Ingresos Residuales Perpetuos
            </p>
          </div>
        </div>
      </footer>

      <WhatsAppButton
        phoneNumber={userdata?.whatsapp}
        message="Hola, me gustaría obtener más información."
        onContactClick={trackContact}
      />
      <LandingChatbot />
      {hasAnySocialLink && (
        <SocialButtons
          pdfUrl={userdata?.pdf || undefined}
          facebookUrl={userdata?.facebook || undefined}
          instagramUrl={userdata?.instagram || undefined}
          linkedinUrl={userdata?.linkedin || undefined}
          tiktokUrl={userdata?.tiktok || undefined}
          calendlyUrl={userdata?.calendly || undefined}
          onContactClick={(network) => console.log(`Se hizo clic en ${network}`)}
        />
      )}
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "100vh",
    backgroundColor: "#f5f5f5",
    color: "#333",
  },
  bannerSection: {
    padding: '80px 0',
    color: 'white',
    textAlign: 'center',
    position: 'relative',
    minHeight: 'auto',
    paddingBottom: '60px',
  },
  bannerContent: {
    maxWidth: '800px',
    margin: '0 auto 40px',
  },
  bannerTitle: {
    fontSize: 'clamp(2rem, 5vw, 3.5rem)',
    fontWeight: 'bold',
    marginBottom: '20px',
    textShadow: '2px 2px 8px rgba(0, 0, 0, 0.7)',
    color: 'white !important',
  },
  bannerSubtitle: {
    fontSize: 'clamp(1rem, 2.5vw, 1.3rem)',
    marginBottom: '20px',
    opacity: 0.95,
    textShadow: '1px 1px 4px rgba(0, 0, 0, 0.6)',
    color: 'white !important',
  },
  content: {
    textAlign: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    width: '100%',
    padding: '40px 20px',
    backgroundColor: 'transparent',
  },
  question: {
    width: "100%",
    marginTop: "20px",
    padding: "30px",
    backgroundColor: "#fff",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
  },
  replayContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '20px',
    textAlign: 'center',
    backgroundColor: 'rgba(0, 0, 0, 0.8)',
    borderRadius: '10px',
  },
  replayImage: {
    width: '150px',
    marginBottom: '20px',
  },
  button: {
    display: "block",
    margin: "10px auto",
    padding: "14px 24px",
    fontSize: "16px",
    fontWeight: "600",
    cursor: "pointer",
    backgroundColor: "#1890ff",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    transition: "all 0.3s",
    width: "90%",
    maxWidth: "400px",
    boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
  },
};

export default Producto3;